// extracted by mini-css-extract-plugin
module.exports = {"video":"AutoPlayVideo_video__8InYY","videoWrap":"AutoPlayVideo_videoWrap__ft7cu"};